// extracted by mini-css-extract-plugin
export var label = "_f4-5";
export var slideContainer = "_f4-0";
export var slider = "_f4-1";
export var sliderLg = "_f4-4";
export var sliderMd = "_f4-3";
export var sliderSm = "_f4-2";